import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RolesManagementService } from 'app/services/roles-management/roles-management.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-roles-creation',
  templateUrl: './roles-creation.component.html',
  styleUrls: ['./roles-creation.component.css']
})
export class RolesCreationComponent implements OnInit {

  commonRoles;
  openPopUp: boolean;
  invalidSubmit: boolean;
  addEditForm: FormGroup;
  update: boolean;
  roleField: any;
  updateDescription: string;

  constructor(
    public rolesManagementService: RolesManagementService, 
    private fb: FormBuilder,
    private translate: TranslateService,
    private messageService: MessageService,
    private router: Router
    ) { }

  ngOnInit() {
    this.loadCommonRole();
    this.rolesManagementService.getRoleFields().subscribe( res => this.roleField = res);
  }

  showAddOrEditDialog(event: any) {
    this.openPopUp = true;
    if (event == null) {
      this.addEditForm = this.fb.group({
        descr: ['']
      });
    } else {
      this.addEditForm = this.fb.group({
        descr: [event.description]
      });
      this.updateDescription = event.description;
      this.update = true;
    }
  }

  closeDialog() {
    this.openPopUp = false;
    this.loadCommonRole();
  }

  saveOrUpdate() {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    const data = {
      description: this.addEditForm.get('descr').value
    }
    if (!this.update) {
      // save
      this.rolesManagementService.createCommonRole(data).subscribe(() => {
        this.messageService.add({severity: 'success', summary: 'Success', detail: this.translate.instant('rolesManagement.creationCommonRoles')});
        this.openPopUp = false;
      });
    } else {
      // update
      this.rolesManagementService.updateCommonRole(data, this.updateDescription).subscribe(() => {
        this.messageService.add({severity: 'success', summary: 'Success', detail: this.translate.instant('rolesManagement.updateCommonRoles')});
        this.openPopUp = false;
      });
    }
  }

  loadCommonRole() {
    this.rolesManagementService.getCommonRoles().subscribe( res => this.commonRoles = res);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/roles-creation/roles-creation.component.ts